export default "../../src/fonts/verdana-bold/Verdana-Bold-V1.woff2";